import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type { GetLeadTimeDetailResponse, LeadTimeRung } from '@erp/rpc';

export type { GetLeadTimeDetailResponse, LeadTimeRung };

export interface UseLeadTimeDetailInput {
  /** Null disables the query (some rows carry no warehouse). */
  warehouseId: string | null;
  /** `im_products_v3.key` (the SKU). Null disables the query too. */
  productV3Key?: string | null;
}

// Observed lead-time calculation detail for one product × warehouse: every
// ladder rung with median/spread/sample count and which rung the resolver
// picked. Fetch lazily (enabled); it backs a click-through dialog.
export function useLeadTimeDetail(
  input: UseLeadTimeDetailInput,
  enabled = true,
) {
  return useQuery<GetLeadTimeDetailResponse>({
    ...orpc.procurement.leadTimes.getDetail.queryOptions({
      input: {
        // Never sent when null; `enabled` gates the fetch below.
        warehouseId: input.warehouseId ?? '',
        productV3Key: input.productV3Key ?? '',
      },
    }),
    enabled: enabled && !!input.warehouseId && !!input.productV3Key,
    staleTime: 60_000,
  });
}
